import React from 'react';

import Hero from '../components/Hero';
import ComparisonCard from '../components/ComparisonCard';
import Section from '../components/Section';

const ComparisonIndexTemplate = ({
  pageContext: { entries: comparisons, page },
}) => (
  <React.Fragment>
    <Section>
      <Hero {...page} />
    </Section>
    <Section colour="light">
      <div className="md:flex md:flex-wrap -mx-6">
        {comparisons.map(item => <ComparisonCard key={item.id} url={`graphcms-as-${item.name.toLowerCase()}-alternative`} {...item} />)}
      </div> 
    </Section>
  </React.Fragment>
);

export default ComparisonIndexTemplate;
